/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-track,
.qds-knob {
  print-color-adjust: exact;
}

.qds-track {
  align-items: center;
  border-radius: var(--qds-control-slider-track-border-radius);
  display: flex;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: var(--qds-control-toggle-padding);
  print-color-adjust: exact;
  background-color: var(--qds-theme-control-slider-track-default);

  &:hover {
    background-color: var(--qds-theme-control-slider-track-hover);
  }

  &:active {
    background-color: var(--qds-theme-control-slider-track-pressed);
  }
}

.qds-knob {
  background-color: var(--qds-theme-control-input-background);
  border-radius: var(--qds-control-slider-knob-border-radius);
  box-shadow: var(--qds-theme-accessory-elevation);
  box-sizing: border-box;
  margin: 0;
}

.qds-container {
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
}

.qds-switch {
  clip-path: inset(50%);
  height: 1px;
  margin: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;

  &:focus-visible ~ .qds-track {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }

  &:checked ~ .qds-track {
    justify-content: flex-end;
    background-color: var(--qds-theme-signature-color-default);

    &:hover {
      background-color: var(--qds-theme-signature-color-hover);
    }

    &:active {
      background-color: var(--qds-theme-signature-color-pressed);
    }
  }
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-size='small'] {
  &.qds-inline {
    margin-block: var(--qds-control-small-padding-auto-height);
  }

  &.qds-track {
    width: var(--qds-control-toggle-box-small-width);
    height: var(--qds-control-toggle-box-small-size);
  }

  &.qds-knob {
    height: var(--qds-control-slider-knob-small-size);
    width: var(--qds-control-slider-knob-small-size);
  }
}

[data-size='standard'] {
  &.qds-inline {
    margin-block: var(--qds-control-standard-padding-auto-height);
  }

  &.qds-track {
    width: var(--qds-control-toggle-box-standard-width);
    height: var(--qds-control-toggle-box-standard-size);
  }

  &.qds-knob {
    height: var(--qds-control-slider-knob-standard-size);
    width: var(--qds-control-slider-knob-standard-size);
  }
}

[data-size='large'] {
  &.qds-inline {
    margin-block: var(--qds-control-large-padding-auto-height);
  }

  &.qds-track {
    width: var(--qds-control-toggle-box-large-width);
    height: var(--qds-control-toggle-box-large-size);
  }

  &.qds-knob {
    height: var(--qds-control-slider-knob-large-size);
    width: var(--qds-control-slider-knob-large-size);
  }
}
